module.exports = __webpack_public_path__ + "static/media/may 2021.db8444de.svg";